import { useSnackbar } from 'notistack';
import { useCallback, useState } from 'react';
import axiosInstance from 'src/utils/axios';
import { APIS } from 'src/utils/serviceUrls';
import { SuccessStory } from '../../../@types/successStory';
import { deleteErrorText } from '../content-order/reorderModel';

export type StoryTab = 'all' | 'story' | 'activity';

// Rows without a type (or with '') are stories, as on the site and in the API's
// reorder scope.
export const storyTypeOf = (story: Pick<SuccessStory, 'type'>): string => story.type || 'story';

export const useSuccessStories = () => {
  const [stories, setStories] = useState<SuccessStory[]>([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [currentStory, setCurrentStory] = useState<SuccessStory | undefined>();
  const { enqueueSnackbar } = useSnackbar();

  const getList = useCallback(async () => {
    const response = await axiosInstance.get(APIS.SUCCESS_STORIES.LIST);
    setStories(Array.isArray(response.data?.data) ? response.data.data : []);
  }, []);

  const handleEditRow = (selected: SuccessStory) => {
    setCurrentStory(selected);
    setModalOpen(true);
  };

  const handleDeleteRow = async (id: string) => {
    try {
      await axiosInstance.delete(APIS.SUCCESS_STORIES.DELETE(id));
      enqueueSnackbar('Deleted Successfully', { variant: 'success' });
    } catch (error) {
      console.error(error);
      enqueueSnackbar(deleteErrorText(error, 'Unable to delete story'), { variant: 'error' });
    }
  };

  return {
    stories,
    setStories,
    modalOpen,
    setModalOpen,
    currentStory,
    setCurrentStory,
    getList,
    handleEditRow,
    handleDeleteRow,
  };
};
